import guards from "@/pages/guards"

const Index = resolve => {
  require.ensure(["./index.vue"], () => {
    resolve(require("./index.vue"))
  }, "customers")
}

const Show = resolve => {
  require.ensure(["./show/show.vue"], () => {
    resolve(require("./show/show.vue"))
  }, "customers")
}

export default class CustomersRouter {

    static addRoutes(appRoutes) {

      appRoutes.push({ path: "customers", component: Index, beforeEnter: guards.onlyNonCustomers })
      appRoutes.push({ path: "customers/show/:code/:unit", component: Show })
    }
}
